import React, { useEffect } from "react";
import InputField from "../../components/form/InputField";
import CommonButton from "../../components/commonButton";
import { Container, Image, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../redux/slice/authSlice";
import { loginSchema } from "../../schema/validationSchemas";
import "./login.css";
import { routes } from "../../routes/pageRoutes";
import useMounted from "../../hooks/useMounted";
import { useToast } from "../../context/TostContext";

export default function LogIn() {
  const { status, error } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hasMounted = useMounted();
  const toast = useToast();

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const result = await dispatch(loginUser(values)).unwrap();

      if (result && result.data.token) {
        localStorage.setItem("auth-token", result.data.token);
        toast.success(result.message || "Logged in successfully!");
        setTimeout(() => {
          if (hasMounted) {
            navigate(routes.userRPoint, { replace: true });
          }
        }, 1000);
      }
    } catch (err) {
      toast.error(err?.message || "Failed to login!");
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (error) {
      const errorMessage =
        typeof error === "string"
          ? error
          : error?.message || "Something went wrong";
      toast.error(errorMessage);
    }

    if (status === "loading") {
      toast.warning("Logging in...");
    }
  }, [status, error, toast]);

  return (
    <>
      <Container fluid="xxl" className="mx-auto px-4">
        <div className="d-flex align-items-center justify-content-center py-4  login-content">
          <div className="position-relative w-100 py-4 login-sub-content">
            <div className="bg-white rounded-2 p-5 common-shadow login-card">
              <h1 className="fs-5 d-flex align-content-center justify-content-center mb-4">
                <Link
                  // to="https://mep.in/"
                  className=" text-decoration-none  d-inline-block w-100 overflow-hidden"
                >
                  <Image src={'/logo-main.png'} alt="Site-Logo" className="d-block w-100" />
                </Link>
              </h1>
              <div className="mb-4 welcome-content">
                <h4 className="mb-1 fw-medium">Welcome to Rpoint!</h4>
                <p>Login seamlessly with mobile number or email</p>
              </div>
              <Formik
                initialValues={{ email: "", password: "" }}
                validationSchema={loginSchema}
                onSubmit={handleSubmit}
              >
                {({
                  values,
                  errors,
                  touched,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <InputField
                      className="mb-4"
                      label={{ name: "Email" }}
                      input={{
                        id: "email",
                        name: "email",
                        type: "email",
                        placeholder: "Enter your email",
                        value: values.email,
                        onChange: handleChange,
                        onBlur: handleBlur,
                      }}
                      validation={{
                        isInvalid: touched.email && errors.email,
                        message: errors.email,
                      }}
                    />
                    <InputField
                      className="mb-5"
                      label={{ name: "Password" }}
                      input={{
                        id: "password",
                        name: "password",
                        type: "password",
                        placeholder: "Enter your password",
                        value: values.password,
                        onChange: handleChange,
                        onBlur: handleBlur,
                      }}
                      validation={{
                        isInvalid: touched.password && errors.password,
                        message: errors.password,
                      }}
                    />
                    <CommonButton
                      title="Login"
                      type="submit"
                      disabled={isSubmitting}
                      variant="primary"
                      className="w-100 justify-content-center primary-shadow"
                    />
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
